module.exports = __webpack_public_path__ + "static/logomedillustrasjon-f9fcb25011ebe8cba9441d3c7742cbae.png";